import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'
import { MidiSelector } from './MidiSelector'

export const Sidebar = () => {
  return (
    <div className="w-80 border-r bg-muted/40 flex flex-col h-screen overflow-y-auto">
      <div className="p-6 border-b">
        <h1 className="text-2xl font-bold">MIDI Microtonal Tuner</h1>
        <p className="text-sm text-muted-foreground mt-1">
          Réglez le tuning microtonal de votre clavier MIDI
        </p>
      </div>
      
      <div className="flex-1 p-6 space-y-6">
        <Card>
          <CardHeader>
            <CardTitle className="text-base">Périphérique MIDI</CardTitle>
          </CardHeader>
          <CardContent>
            <MidiSelector />
          </CardContent>
        </Card>



        
      </div>
    </div>
  )
}

